module.exports = __webpack_public_path__ + "static/media/296422.18b62359.png";